import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Divider, Form, Button } from "semantic-ui-react";
import DateRangePicker from 'rsuite/DateRangePicker';
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const PopupHomeEdit = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [idPopup, setIdPopup] = useState('')
    const [information, setInformation] = useState('')
    const [image, setImage] = useState([])
    const [url, setUrl] = useState('')

    const handleImageChange = (e) => {
        let file = e.target.files
        setImage(file[0])
    }

    const handleSubmit = () => {
        const param = new FormData()
        param.append("id_popup", idPopup)
        param.append("information", information)
        param.append("image", image)
        param.append("url", url)
        console.log(url)
        axios({
            method:"POST",
            url:`${global.SRV}api_rudrunner_cms/controler/popup.php/?index=5`,
            headers:{'Content-Type': 'text/plain'},
            data:param
        })
        .then (res => { console.log(res.data)
            if (res.data.state === 200){
                navigate('/popup_home')
            } else if (res.data.state === 300) {
                alert(res.data.message + ' : ' + res.data.file_type)
            } else {
                alert(res.data.error)
            }
        })
    }

    useEffect(() => { 
        let data = location.state
        setInformation(data.information)
        setImage(data.image)
        setIdPopup(data.id_popup)
        setUrl(data.url)
    }, [])
    
    return (
        <Container fluid>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Edit Popup</div>
                <div className="text-muted">Edit information for Popup</div>
            </Row>
            <Divider />
            <Row className="d-flex justify-content-center mb-3 mt-3">
                <Col xl={6} lg={10} md={12} sm={12} className="mb-3">
                    <Form widths="equal" onSubmit={handleSubmit}>
                        <Form.Field>
                            <Form.Input type="text" label="Information" defaultValue={information} onChange={(e, { value }) => setInformation(value)} />
                        </Form.Field>
                        <Form.Field>
                            <Form.Input type="text" label="Url CTA" defaultValue={url} onChange={(e,{value}) => setUrl(value)}/>
                        </Form.Field>
                        <Form.Input
                            label="Image"
                            type="file"
                            icon="image"
                            className="mb-0 mt-3"
                            onChange={(e) => handleImageChange(e)}
                        />
                        <small className="text-muted">Images must be in *.png format and file size no more than 500kb</small>
                        <Form.Field className="mt-4">
                            <Form.Button content="Update Popup" color="facebook" />
                        </Form.Field>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default PopupHomeEdit